<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        large
        ref="RkmModal"
        title="Listagem de residentes"
    >

        <rkm-alert>
            Verifique se os pacientes abaixo necessitam de atualização.
        </rkm-alert>

        <rkm-table
            :fields="fields"
            :items="items"
            sort-by="nome"
            hide-filters
            hide-pagination
        />
    </rkm-modal>
</template>

<script>

export default {
    computed: {
        items() {
            return this.data.form.residentes && this.data.form.residentes.length > 0
                ? this.data.form.residentes.filter(item => item.pacienteId != this.data.model.id)
                : []
        },
        fields() {

            const fields = [
                {
                    key: 'nome',
                    label: 'Nome',
                    class: 'col-8',
                    sortable: true
                },
                {
                    key: 'prontuario',
                    label: 'Prontuário',
                    class: 'col-4',
                    sortable: true
                }
            ]

            return fields
        },
    },
    data: () => ({
        loading: false,
        model: {},
        repositories: {},
        exames: [],
    }),
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>